<template>
  <ul class="checkboxButtons">
    <li v-for="(item, i) in items" :key="i">
      <CheckboxButton
        :name="name"
        :label="item.label"
        :id="item.id"
        :error="item.error"
        :value="item.value"
        :checked="item.checked"
        @call-input-change="changeCheckbox($event)"
        narrow
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Checkbox } from '@/types/InputItems'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'

export default defineComponent({
  components: {
    CheckboxButton
  },

  props: {
    name: {
      type: String
    },
    items: {
      type: Array as PropType<Checkbox[]>
    }
  },

  setup(_, { emit }) {
    const changeCheckbox = (obj: { value: string; checked: boolean }) => {
      emit('change-checkbox', obj)
    }

    return {
      changeCheckbox
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.checkboxButtons {
  display: flex;
  flex-wrap: wrap;
  margin: -7px;

  @include mixins.media() {
    margin: 0 -20px;
  }

  &:not(:first-child) {
    margin-top: 24px;
  }

  & > li {
    margin: 7px;
    flex-basis: calc(50% - 14px);

    @include mixins.media() {
      flex-basis: calc(33.333% - 40px);
      margin: 8px 20px;
    }
  }
}
</style>
